
import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { Badge } from "primereact/badge";




export default function GastoEstimadoPJ({
  gastoEstimadoPJ
}: {
  gastoEstimadoPJ
  : any
}) {
  const { t } = useTranslation();

  return (
    <Panel header={t('gastoEstimadoPJ')}>
       <div className="grid">
          <div className="col">
            <p style={{color: 'rgb(113, 113, 122)'}}><b>Faixa gasto estimado Mensal:</b> <Badge style={{backgroundColor: 'rgb(0, 85, 128)', fontSize:'1.4rem'}} value={gastoEstimadoPJ.faixaGasto}></Badge></p>
          </div>
          <div className="col">
            <p style={{color: 'rgb(113, 113, 122)'}}><b>Faixa percentual gasto estimado Mensal:</b> <Badge style={{backgroundColor: 'rgb(0, 85, 128)', fontSize:'1.4rem'}} value={gastoEstimadoPJ.faixaPercentual}></Badge></p>
          </div>
        </div>
        {gastoEstimadoPJ.gasto && (
          <div className="grid">
            <div className="col">
              <p style={{color: 'rgb(113, 113, 122)'}}><b>Gasto estimado Mensal:</b> <Badge style={{backgroundColor: 'rgb(0, 85, 128)', fontSize:'1.4rem'}} value={gastoEstimadoPJ.gasto}></Badge></p>
            </div>
            <div className="col">
              <p style={{color: 'rgb(113, 113, 122)'}}><b>Percentual gasto estimado Mensal:</b> <Badge style={{backgroundColor: 'rgb(0, 85, 128)', fontSize:'1.4rem'}} value={gastoEstimadoPJ.percentual}></Badge></p>
            </div>
          </div>
        )}
        
       
    </Panel>
  )
}
